import { render, staticRenderFns } from "./theoryPracticeList.vue?vue&type=template&id=2c904524&scoped=true"
import script from "./theoryPracticeList.vue?vue&type=script&lang=js"
export * from "./theoryPracticeList.vue?vue&type=script&lang=js"
import style0 from "./theoryPracticeList.vue?vue&type=style&index=0&id=2c904524&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c904524",
  null
  
)

export default component.exports